import moment from "moment";
import React from "react";

export function GochiKidBannerDetailModal(props) {
  return (
    <>
      <div
        className={
          props.showing
            ? "custom-modal-container group-special-gochi-kid-modal gochi-kid-banner-detail-modal show-modal"
            : "custom-modal-container group-special-gochi-kid-modal"
        }
        size="sm"
      >
        <div
          className={
            props.showing
              ? "modal modal-action modal-dialog is-show history-modal max-width-335"
              : "modal modal-action modal-dialog history-modal max-width-335"
          }
        >
          <div className="title-modal title-modal-charge">
            <div className="title">募集詳細</div>
            <div className="note color-EC4A56">
              ※下記募集詳細の条件に該当するお子さまで、まだご登録がお済みでない方がいらっしゃる場合は、モニター利用のタイミングまでに、お子さまのご登録から審査OKまで完了することを推奨します。
            </div>
          </div>
          <div className={`modal-body`}>
            <div>■モニター名</div>
            <div>{props.bannerDetail?.gochiKidGroupName}</div>
            <br />
            <div>■対象のお子さま（敬称略）</div>
            <div>{props.bannerDetail?.listNickName}</div>
            <br />
            {props.bannerDetail?.description && (
              <>
                <div>■ご提供内容</div>
                <div className="description">{props.bannerDetail?.description}</div>
                <br />
              </>
            )}
            <div>■応募の受付期間</div>
            <div>
              {`${moment(props.bannerDetail?.bannerStartTime).format(
                "YYYY年MM月DD日 HH:mm:ss",
              )} 〜 
              ${moment(props.bannerDetail?.bannerEndTime).format(
                "YYYY年MM月DD日 HH:mm:ss",
              )}`}
            </div>
            <div>※応募・募集状況により、予告なく終了する場合がございます。</div>
            <br />
            <div>■募集世帯数 ※先着</div>
            <div>{props.bannerDetail?.bannerUserLimitNum?.toLocaleString()}世帯</div>
            <br />
            <div>■モニター実施の期間</div>
            <div>
              開始日：
              {props.bannerDetail?.startTime
                ? moment(props.bannerDetail?.startTime).format(
                    "YYYY年MM月DD日 HH:mm:ss",
                  )
                : ""}
            </div>
            <div>
              終了日：
              {props.bannerDetail?.endTime
                ? moment(props.bannerDetail?.endTime).format(
                    "YYYY年MM月DD日 HH:mm:ss",
                  )
                : ""}
            </div>
          </div>
          <div className="modal-footer">
            {props.bannerDetail?.applyFlag === null && (
              <div>
                <button
                  onClick={() => props.handleOpenGochiKidSurvey()}
                  className="btn btn-rect btn-survey"
                >
                  応募に進む
                </button>
              </div>
            )}
            <div>
              <button
                onClick={() => props.handleClose()}
                className={"btn btn-outline-rect btn-text"}
              >
                前の画面に戻る
              </button>
            </div>
          </div>
        </div>
        <div
          onClick={() => props.handleClose()}
          className={`back-drop ${
            props.accessToken && props.accessCode ? "back-drop-bold" : ""
          }`}
        />
      </div>
    </>
  );
}
